import { FooterApiResponse } from '@/types/footer';

/**
 * Client-side API call for footer data
 */
export async function fetchFooterData(): Promise<FooterApiResponse> {
  const response = await fetch('/api/footer');

  if (!response.ok) {
    throw new Error(`Failed to fetch footer data: ${response.statusText}`);
  }

  return await response.json();
}

/**
 * Server-side API call for footer data
 */
export async function getFooterData(): Promise<FooterApiResponse> {
  try {
    // During build time, import the data directly instead of making HTTP requests
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PHASE === 'phase-production-build') {
      const footerData = await import('@/data/footer.json');
      return footerData.default;
    }

    // During development, try to fetch from API
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000';
    const response = await fetch(`${baseUrl}/api/footer`);

    if (!response.ok) {
      throw new Error(`Failed to fetch footer data: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching footer data server-side:', error);
    // Fallback to direct import if fetch fails
    try {
      const footerData = await import('@/data/footer.json');
      return footerData.default;
    } catch (importError) {
      console.error('Error importing footer data:', importError);
      throw error;
    }
  }
}
